const documentsPage = {
  searchDocuments: "Search documents...",
  refresh: "Refresh",
  newDocument: "New Document",
  noDocuments: "No documents",
  total: "Total",
  currentlyViewing: "Currently viewing",
  signed: "signed",
  expired: "Expired",
  now: "now",
  minutesAgo: "{n}m ago",
  hoursAgo: "{n}h ago",
  daysAgo: "{n}d ago",
  draft: "Draft",
  sent: "Sent",
  viewed: "Viewed",
  partiallySigned: "Partial",
  signedStatus: "Signed",
  archived: "Archived",
  analytics: "Analytics",
  completionRate: "Completion Rate",
  completed: "completed",
  pending: "pending",
  signerProgress: "Signer Progress",
  signersSigned: "signed",
  avgSignTime: "Avg Sign Time",
  documentsAnalyzed: "documents",
  expiringSoon: "Expiring Soon",
  within7Days: "within 7 days",
  needsAttention: "needs attention",
} as const;
export default documentsPage;
